module.exports = __webpack_public_path__ + "static/media/jackpots-lvl1.351b4141.png";